/* global WP */

const relatedItineraryBlocks = [];

const fetchItineraries = (index) => {
	const {
		postsContainer,
		loadMoreButton,
		initialPosts,
		currentPage,
		postsPerPage,
		totalPosts,
		nonce,
	} = relatedItineraryBlocks[index];

	const data = {
		action: 'fetch_itineraries',
		currentPage,
		postsPerPage,
		initialPosts,
		security: nonce,
	};
	const formData = new FormData();
	for (const key in data) {
		formData.append(key, data[key]);
	}
	const params = new URLSearchParams(formData);

	return new Promise((resolve, reject) => {
		fetch(WP.ajaxUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache',
			},
			credentials: 'same-origin',
			body: params,
		})
			.then((response) => {
				// console.log(response);
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((json) => {
				const { html } = json;

				postsContainer.innerHTML += html;

				relatedItineraryBlocks[index].currentPage++;

				// If we're on the last page, disable the load more button
				if (
					(currentPage + 1) * postsPerPage + initialPosts >=
					totalPosts
				) {
					loadMoreButton.disabled = true;
				}

				resolve();
			})
			.catch((error) => {
				console.log(error); // eslint-disable-line no-console
				reject(error);
			});
	});
};

const handleLoadItineraries = async (index) => {
	const {
		posts,
		loadMoreButton,
		postSelection,
		totalPosts,
		initialPosts,
		currentPage,
		postsPerPage,
	} = relatedItineraryBlocks[index];

	if ('manual' === postSelection) {
		if (currentPage * postsPerPage + initialPosts >= totalPosts) {
		}

		const offsetStart = currentPage * postsPerPage + initialPosts;
		const offsetEnd = (currentPage + 1) * postsPerPage + initialPosts;
		const itemsToShow = Array.from(posts).slice(offsetStart, offsetEnd);

		itemsToShow.forEach((item) => {
			item.classList.remove('hidden');
		});

		if ((currentPage + 1) * postsPerPage + initialPosts >= totalPosts) {
			loadMoreButton.disabled = true;
		} else {
			relatedItineraryBlocks[index].currentPage++;
		}
	} else {
		await fetchItineraries(index);
	}
};

const relatedItineraryPosts = () => {
	const blocks = document.querySelectorAll('.block-related-posts-itinerary');
	if (blocks.length) {
		blocks.forEach((block, index) => {
			const posts = block.querySelectorAll('.itinerary-card');
			const postsContainer = block.querySelector(
				'.block-related-posts-itinerary__post-grid'
			);
			const loadMoreButton = block.querySelector(
				'.block-related-posts-itinerary__load-more-button'
			);

			// Extract settings from json data attribute
			const jsonData = JSON.parse(
				block.getAttribute('data-json-settings')
			);
			const {
				initial_posts: initialPosts,
				post_selection: postSelection,
				posts_per_page: postsPerPage,
				total_posts: totalPosts,
				security_nonce: nonce,
			} = jsonData;

			relatedItineraryBlocks.push({
				posts,
				postsContainer,
				loadMoreButton,
				postSelection,
				totalPosts,
				initialPosts,
				currentPage: 0,
				postsPerPage,
				nonce,
			});

			if (loadMoreButton) {
				loadMoreButton.addEventListener('click', function () {
					handleLoadItineraries(index);
				});
			}
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		relatedItineraryPosts();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
